import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import { ChangeEvent, useContext } from 'react'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType, getFieldControlId } from '../types'

/**
 * Date field (with label/outlined variant).
 */
export const DataEditContextDateResolutionField = <T extends AnyObject>({
  field,
}: {
  field: EditableFieldsOfType<T, string>
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, disabled, setFields, t } = useContext<ContextValue<T>>(Context)
  const controlId = getFieldControlId(field)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFields({ [field]: e.target.value })
  }

  const value = flatData[field] as unknown as string

  return (
    <div>
      <RadioGroup value={value} onChange={handleChange} data-testid={`radio-field-${controlId}`}>
        <FormControlLabel
          value="day"
          control={<Radio disabled={disabled[field]} />}
          label={t('dateResolution.fullDate')}
        />
        <FormControlLabel
          value="month"
          control={<Radio disabled={disabled[field]} />}
          label={t('dateResolution.month')}
        />
        <FormControlLabel
          value="year"
          control={<Radio disabled={disabled[field]} />}
          label={t('dateResolution.year')}
        />
      </RadioGroup>
    </div>
  )
}

/**
 * Default CV radio field (set / unset).
 */
